import {
  DropdownIndicator,
  formatGroupLabel,
  getTranslatedText,
  IndicatorSeparator,
  AppContext
} from '@nile/components';
import { TextField } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState, useContext } from 'react';
import { injectIntl } from 'react-intl';
import Select from 'react-select';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { QUANTITY_OPTIONS } from './constants';
import { EditIcon } from '@nile/components/src/Icons';

function ItemQuantity(props) {
  const {
    intl,
    item,
    updateItem,
    handlePropertiesChange,
    isDisabled,
    flags,
    disabledSections,
    isIntegrationAddOnItem,
    integrationAddOn,
    entryPoint
  } = props;
  const appContext = useContext(AppContext);
  // const planId = appContext.user?.chargeBeePlanId?.toLowerCase();

  const { quantity, quantityType, unitType, change } = item;
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const [selectedUnitType, setSelectedUnitType] = useState(unitType);
  const [selectedQuantity, setSelectedQuantity] = useState(quantity);

  let planNameGrow = '';
  if (flags?.connectPlan) {
    planNameGrow = 'standard-psa';
  }
  // const quantityTypes = QUANTITY_OPTIONS.filter((el) => {
  //   return planId !== planNameGrow && el?.name === 'ASSET_VIEW';
  // }).map((ele) => ({ ...ele, label: getTranslatedText(intl, ele.label) }));
  const filteredQuantityOptions =
    integrationAddOn || isIntegrationAddOnItem
      ? QUANTITY_OPTIONS.filter((el) => {
          // Don't change the order. Filter custom and integration usage for integration item and type as integration usage
          // Filter custom only for integration add on and not other quantity types.

          if (integrationAddOn || entryPoint === 'INTEGRATION') {
            return el.name === 'CUSTOM' || el.name === 'INTEGRATION_USAGE';
          }
          if (isIntegrationAddOnItem) {
            return el.name === 'CUSTOM';
          }

          return false;
        })
      : QUANTITY_OPTIONS.filter((el) => el.name !== 'INTEGRATION_USAGE');
  const quantityTypes = filteredQuantityOptions.map((el) => {
    return {
      ...el,
      label: getTranslatedText(intl, el.label)
    };
  });
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;
  const editable = true;
  return (
    <div className="flex actr pr10 mw-100">
      <Select
        isClearable
        name="subscriptionTypes"
        className="min-width-150"
        value={quantityTypes.find((el) => el.name === unitType)}
        onChange={(val) => {
          handlePropertiesChange({
            quantity: val.name === 'CUSTOM' ? selectedQuantity : null,
            unitType: val.name,
            change: {
              ...change,
              quantity: null
            }
          });
        }}
        options={quantityTypes}
        components={{
          IndicatorSeparator,
          DropdownIndicator
        }}
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        menuPlacement="auto"
        placeholder={getTranslatedText(
          intl,
          'admin.serviceCatalog.quantity.placeholder'
        )}
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 })
        }}
        isDisabled={
          isDisabled ||
          (disabledSections && disabledSections.includes('itemQuantity'))
        }
      />
      {unitType === 'CUSTOM' && (
        <TextField
          value={selectedQuantity?.toString()}
          placeholder={getTranslatedText(
            intl,
            'client.contractTemplate.form.quantityType.placeholder'
          )}
          maxLength={10}
          onChange={(val) => {
            setSelectedQuantity(val);
            handlePropertiesChange({
              quantity: val
            });
          }}
          min={0}
          disabled={
            disabledSections && disabledSections.includes('itemQuantity')
          }
          type="number"
        />
      )}
    </div>
  );
}

export default injectIntl(withLDConsumer()(ItemQuantity));
